import { TextField, Typography } from '@mui/material';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { NewMoneyFormatv2 } from '../../../library/MoneyFormat';
import { showWarningSnackbar } from '../../../components/snackBar/snakbar';

const FormikMoneyInput = memo(
  React.forwardRef(({ formik, name, label, viewPage, setGstApi }, ref) => {
    const [value, setValue] = useState('');
    const handleChange = (event) => {
      if (name === 'creditPeriod') {
        if ((event.target.value > 0 && event.target.value < 1200) || event.target.value === '') {
          if (/^\d+$/.test(event.target.value)) {
            setValue(event.target.value);
          } else {
            formik.setFieldValue(name, '');
            setValue('');
          }
        } else if (event.target.value >= 1200) {
          showWarningSnackbar('Invalid days');
        }
      } else if (name !== 'creditPeriod') {
        const credit = event.target.value.replace(/,/g, '');
        if (credit < 10000000000 || event.target.value === '') {
          if (/^\d+$/.test(credit)) {
            setValue(credit);
          } else if (credit.length === 0) {
            formik.setFieldValue(name, '');
            setValue('');
          } else {
            //  formik.setFieldValue(name, '');
            showWarningSnackbar('Invalid value');
          }
        } else {
          showWarningSnackbar('Invalid Amount');
        }
      }
    };
    return (
      <>
        <TextField
          label={label}
          disabled={viewPage}
          inputProps={{ maxLength: 30 }}
          value={(function () {
            const rawSource = value !== '' ? value?.toString() : formik?.values[name]?.toString();
            const cleaned = (rawSource || '').replace(/,/g, '');
            if (cleaned === '') return '';
            const numeric = Number(cleaned);
            if (!isNaN(numeric) && numeric === 0) return '';
            return NewMoneyFormatv2(cleaned);
          })()}
          onChange={handleChange}
          onFocus={() => {
            setValue(formik.values[name]?.toString());
            formik.setFieldTouched([name], true);
          }}
          sx={{
            '.MuiFormLabel-asterisk': {
              color: 'danger.main',
              fontSize: '20px',
              fontWeight: 'bold',
            },
          }}
          fullWidth
          onBlur={() => {
            const raw = (value ?? formik.values[name] ?? '').toString();
            const cleaned = raw.replace(/,/g, '');
            setValue('');
            formik.setFieldValue(name, cleaned);
          }}
          // disabled={true}
          size="small"
          name={name}
        />
        {formik.touched?.[name] && formik.errors?.[name] ? (
          <Typography variant="body1" className="error" style={{ fontSize: 12, padding: 0 }}>
            {formik.errors[name]}
          </Typography>
        ) : (
          <p style={{ padding: 9 }} />
        )}
      </>
    );
  })
);
export default FormikMoneyInput;
